import Papa from "papaparse";
import { readSheet } from "read-excel-file/browser";

/**
 * Reads a .csv or .xlsx file into a header row plus data rows (arrays of strings).
 * Only the first worksheet of a workbook is read. Blank rows are dropped.
 */
export async function parseImportFile(file) {
  const name = (file?.name || "").toLowerCase();
  let table;
  if (name.endsWith(".csv")) {
    table = await new Promise((resolve, reject) => {
      Papa.parse(file, {
        skipEmptyLines: "greedy",
        complete: (result) => resolve(result.data),
        error: reject,
      });
    });
  } else if (name.endsWith(".xlsx")) {
    table = await readSheet(file);
  } else {
    throw new Error("Upload a .csv or .xlsx file.");
  }

  const rows = (table || [])
    .map((r) => (r || []).map((c) => (c == null ? "" : String(c).trim())))
    .filter((r) => r.some((c) => c !== ""));
  if (rows.length < 2) {
    throw new Error("The file needs a header row and at least one data row.");
  }
  const [headers, ...data] = rows;
  return { headers: headers.map((h, i) => h || `Column ${i + 1}`), rows: data };
}
